import { createFileRoute } from '@tanstack/react-router';

// The tenant select alone, with no tenant chosen
export const Route = createFileRoute('/_authenticated/sitemaps/')({});
